import { useRef } from 'react'
import { useState } from './useState'
import { useEffect } from '.'

const useContainerWidth = (): [React.RefObject<HTMLDivElement>, number] => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerWidth, setContainerWidth] = useState(0)

  useEffect(() => {
    let frameId: number | null = null
    const handleResize = () => {
      const nextWidth = containerRef.current?.clientWidth || 0
      setContainerWidth(previousWidth =>
        previousWidth === nextWidth ? previousWidth : nextWidth,
      )
    }

    const resizeObserver = new ResizeObserver(() => {
      if (frameId !== null) {
        cancelAnimationFrame(frameId)
      }
      frameId = requestAnimationFrame(handleResize)
    })

    if (containerRef.current) {
      handleResize()
      resizeObserver.observe(containerRef.current)
    }

    return () => {
      if (frameId !== null) {
        cancelAnimationFrame(frameId)
      }
      resizeObserver.disconnect()
    }
  }, [])

  return [containerRef, containerWidth]
}

export default useContainerWidth
